﻿

$(document).ready(function () {
    $("body").on("submit", "form", function () {
        $(this).submit(function () {
            return false;
        });
        return true;
    });
    //check if any errors to alert to user
    let urlParams = getUrlParams(location.search);
    if (typeof urlParams.AlertError !== "undefined") alert(urlParams.AlertError.replace(/%20/g, " "));
    //resize body
    realign();
    //if sidebar is not open then change trext
    var elementAmoToggle = document.getElementById('toggleButtonAMO');
    if (!$('.sidebar-tab-button').parent().hasClass('open') && typeof (elementAmoToggle) !== 'undefined' && elementAmoToggle !== null) {
        document.getElementById('toggleButtonAMO').textContent = "Open";
    }

    // login validation UX
    $('.text-danger').css({ 'display': 'none' });
    $('#login-btn').click(function () {
        if ($('.text-danger').text() === "") {
            $('.text-danger').css("display", "none");
        } else {
            $('.text-danger').fadeIn().css("display", "inline-block");
        }
    });

    // datepicker
    var date = "";
    $('.date-input').each(function () {
        if ($(this).hasClass('month-year-format')) {
            formatDate("mm-yyyy");
        } else if ($(this).hasClass('date-time-format')) {
            formatDate();
        } else if ($(this).hasClass('dd-mm-yyyy')) {
            formatDate("dd-mm-yyyy");
            //} else if ($(this).hasClass('dd-mm-yyyy-HH-mm')) {
            //    formatDate("dd-mm-yyyy HH:mm");
        } else {
            formatDate();
        }
    });

    // month picker class initializer
    $('.month-input').each(function () {       
        $(this).MonthPicker({ Button: false });
    });

    // format time
    $('.hh-mm-ss').each(function () {
        formatDate("hh-mm-ss");
    });

    try {
        $('.date-time-picker').datetimepicker({
            // dateFormat: 'dd-mm-yy',
            defaultDate: new Date(),
            format: 'd/m/Y h:m:s',
            showSecond: true
        });
    } catch (err) {
        $('.date-time-picker').attr("placeholder", "dd/mm/yyyy 00:00:00");
    }

    // apply title attribute to all selected values of dropdowns inside general forms
    $('.general-form').find('select').change(function () {
        if ($(this).val() !== $(this).find('option:first').val()) {
            $(this).prop('title', $(this).find('option:selected').text());
        } 
    });

    $('hh-mm-ss').change(function () {
        formatDate("hh-mm-ss");
    });

    // format date on change
    $('.dd-mm-yyyy').change(function () {
        formatDate("dd-mm-yyyy");
    });

    $('.month-year-format').change(function () {
        formatDate("mm-yyyy");
    });

    // format date function
    function formatDate(format) {
        if (format === "mm-yyyy") {
            $(".month-year-format").each(function () {
                $(this).datepicker();
                date = $(this).val();
                date = date.substring(date.indexOf('/') + 1).replace(' 00:00:00', '');
                $(this).val(date);
            });
        } else if (format === 'dd-mm-yyyy') {
            $(".dd-mm-yyyy").each(function () {
                $(this).datepicker();
                date = $(this).val();
                date = date.replace(' 00:00:00', '');
                $(this).val(date);
                $(this).attr('value', date);
            });
        } else if (format === 'hh-mm-ss') {
            $(".hh-mm-ss").each(function () {
                $(this).val("");
                $(this).datepicker();
                date = $(this).val();
                date = date + ' 00:00:00';
                $(this).val(date);
                $(this).attr('value', date);
            });
        }
    }


    // get pathname and search query
    var currentPathname = window.location.pathname + location.search;

    // check for tasks
    if (currentPathname.indexOf("/Tasks") > 0 || currentPathname.indexOf("/tasks") > 0) {
        // replace checked checkboxes with css styled text
        $('#tasks-table').find('td').each(function () {
            if ($(this).html().includes('type="checkbox"')) {
                if ($(this).find('input[type=checkbox]').prop('checked')) {
                    $(this).html('Open').addClass("open");
                } else {
                    $(this).html('Closed').addClass("closed");
                }
            }
            if ($(this).text().includes('100')) {
                $(this).addClass("closed");
            }
        });
    }

    // tasks status label for details page // converting checkbox into 'Open' | 'Closed' labels
    var statusBoxDetails = $('.details-task-status');
    var detailsStatus = statusBoxDetails.find('input[type="checkbox"]').attr("checked");

    if (detailsStatus === "checked") {
        statusBoxDetails.html("<label>Status: Open</label>");
    } else {
        statusBoxDetails.html("Status: Closed");
    }

    // show task status based on user input on edit
    // disable and darken inputs if task has been closed
    var switchBox = $('#edit-tasks-table').find('.switch').find('input[type=checkbox]');
    if (switchBox.prop('checked')) {
        $('#UserTasks_Active').prop('checked', true).attr('checked', true);
        $('.task-status').text("Open").addClass("open").removeClass("closed");
        $('#edit-tasks-table').find('input, select, textarea').each(function () {
            $(this).prop('disabled', false);
            $(this).css("filter", "brightness(100%)");
        });
    } else {
        $('#UserTasks_Active').prop('checked', false).attr('checked', false);
        $('.task-status').text("Closed").addClass("closed").removeClass("open");
        $('#edit-tasks-table').find('input, select, textarea').each(function () {
            if ($(this).prop('type') !== 'checkbox') {
                $(this).prop('disabled', true);
                $(this).css("filter", "brightness(40%)");
            }
        });
    }

    // similar function as above, but triggered on change
    $('input[type=submit]').prop('disabled', false).css("filter", "brightness(100%)");
    switchBox.change(function () {
        if (switchBox.prop('checked')) {
            $('#UserTasks_Active').prop('checked', true).attr('checked', true);
            $('.task-status').text("Open").addClass("open").removeClass("closed");
            $('#edit-tasks-table').find('input[type="text"], input[type="number"], select, textarea').each(function () {
                $(this).prop('disabled', false);
                $(this).css("filter", "brightness(100%)");
            });
        } else {
            $('#UserTasks_Active').prop('checked', false).attr('checked', false);
            $('.task-status').text("Closed").addClass("closed").removeClass("open");
            $('#edit-tasks-table').find('input[type="text"], input[type="number"], select, textarea').each(function () {
                if ($(this).prop('type') !== 'checkbox') {
                    $(this).prop('disabled', true);
                    $(this).css("filter", "brightness(40%)");
                }
            });
        }
    });

    // range slider dynamic background color
    var slider = $('input[type="range"]');
    var val = (slider.val() - slider.attr('min')) / (slider.attr('max') - slider.attr('min'));
    slider.css('background-image',
        '-webkit-gradient(linear, left top, right top, '
        + 'color-stop(' + val + ', #94A14E), '
        + 'color-stop(' + val + ', #C5C5C5)'
        + ')'
    );
    slider.prop("disabled", true);

    var searchbox = true;
    // search box toggle
    $('.search-toggle').click(function () {
        searchbox = true;
        $('.body-underlay').removeClass('hidden').fadeIn();
        $('.search-results-container').fadeIn(400);
        $(this).find('svg').toggleClass('fa-times-circle fa-search');
    });

    // underlay click to close search box
    // close search box button
    $('.close-search, .body-underlay').click(function () {
        searchbox = false;
        $('.search-results-container').fadeOut(400);
        $('.body-underlay').fadeOut();
        $('.search-toggle').find('svg').toggleClass('fa-times-circle fa-search');
    });

    // clear search query
    $('.clear-query').click(function () {
        var splittedString = window.location.href.split('?')[0];
        window.location.replace(splittedString);
    });

    // fade out message box on user click close icon
    $('.query-message').children().click(function () {
        $(this).parent().fadeOut();
        $(".table-details").find("td").each(function () {
            result = $(this).text().toLowerCase();
            if (result.includes(searchString.toLowerCase())) {
                $(this).removeClass('searchStringHighlight');
            }
        });
    });

    var sidebar = $(".sidebar-overlay");
    var menuUnderlay = $(".menu-underlay");
    var menuIcon = $(".primary-menu").find('span');

    // sidebar
    $('.primary-menu, .menu-underlay').click(function () {
        $('.primary-menu').toggleClass('open');
        $('.sidebar-overlay').toggleClass('open');
        $('.menu-underlay').fadeToggle();
    });

    // WAPsidebar
    //$('.WAP-menu, .menu-underlay').click(function () {
    //    $('.WAP-menu').toggleClass('open');
    //    $('.sidebar-overlay').toggleClass('open');
    //    //$('.menu-underlay').fadeToggle();
    //});

    // Check for login page
    var loc = window.location;
    if (loc.path === "/Account/Login") {
        $('.primary-menu').hide();
        $('.sign-out').hide();
        $('body').css("overflow", "hidden");
    }

    // message overlay fadeout
    $('#register, #button-back').click(function () {
        $('.register-overlay, .register-underlay').fadeToggle();
    });

    // Greating message
    var thehours = new Date().getHours();
    var themessage;
    var morning = 'Good morning';
    var afternoon = 'Good afternoon';
    var evening = 'Good evening';

    if (thehours >= 0 && thehours < 12) {
        themessage = morning;

    } else if (thehours >= 12 && thehours < 17) {
        themessage = afternoon;

    } else if (thehours >= 17 && thehours < 24) {
        themessage = evening;
    }
    // prepend message based on time of day.
    $('.greeting').prepend(themessage);

    // table find details icon and padding next cells away
    $('.table-icon').find('.fa-info-circle').parent().parent().parent().next().css({ 'padding-left': '10px' });
    // adding background hover class to edit action cells
    $('.table-icon').parent().parent().addClass('hover-background');

    //// select all page permissions checkboxes
    // set checkbox attribute to false on load
    $('.page-perms-table').find('.page-perms-check-all').attr('checked', false);

    // loop through all inputs in chosen table and select them on click of the 'check-all' checkbox
    $('.page-perms-table').find('.page-perms-check-all').click(function () {
        $(this).prop("checked", !$(this).prop("checked"));
        $(this).closest('section').find('input:not(.noCheckAll)').each(function () {
            if (!$(this).hasClass('.noCheckAll')) {
                $(this).prop("checked", !$(this).prop("checked"));
                $(this).attr("checked", !$(this).attr("checked"));
                $(this).trigger('change');
            }
        });

    });


    // create link for table rows
    $('.row-link').click(function () {
        window.location = $(this).find('.task-row').find('a').attr('href');
    });
    $('.row-link').hover(function () {
        $(this).css("cursor", "pointer");
    });

    // timer countdown for redirect error pages
    var timerCountdown = $('.redirectTimer');
    if ($(timerCountdown)[0]) {
        var timeleft = 10;
        var downloadTimer = setInterval(function () {
            timerCountdown.html(timeleft);
            timeleft -= 1;
            $('.closeBtn').click(function () {
                clearInterval(downloadTimer);
                $('.redirectErrorBox').fadeOut();
            });

            if (timeleft <= 0) {
                clearInterval(downloadTimer);
                $('.redirectErrorBox').delay(500).fadeOut();
                document.location.href = "/";
            }
        }, 1000);
    }

    // select on change submit 
    $('.dropdown-submit').change(function () {
        $(this).closest('form').trigger('submit');
    });

    // sanitize each dropdown that contains the sanitize-dropdown class
    var dropdownName = "";
    $('.sanitize-dropdown').each(function () {
        dropdownName = $(this);
        sanitizeDropdown(dropdownName);
    });

    // sanitize select options
    function sanitizeDropdown(dropdown) {
        // gets each option value from DB and push to array to be filtered
        var optionArray = [];
        dropdown.find('option').each(function () {
            if ($(this).val().length > 0 && $(this).val()) {
                optionArray.push($(this).val());
            }
        });

        // remove duplicates
        var unique = optionArray.filter(onlyUnique);

        // clear html options to replace with new array
        dropdown.html("").prepend("<option value=''>-- Select --</option>");
        // append new array values as elements
        for (var i = 0; i < unique.length; i++) {
            dropdown.append("<option value='" + capitalizeFirstLetter(unique[i]) + "'>" + capitalizeFirstLetter(unique[i]) + "</option>");
        }
        // capitaize first letter
        function capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
        // gets only unique strings only
        function onlyUnique(value, index, self) {
            return self.indexOf(value) === index;
        }
    }

    $(".dropdown-sort").each(function sortlist() {
        var lb = this;
        arrTexts = new Array();
        arrTexts1 = new Array();

        for (i = 0; i < lb.length; i++) {
            arrTexts[i] = lb.options[i].value;
            arrTexts1[i] = lb.options[i].text;
        }

        arrTexts.sort();

        for (i = 0; i < lb.length; i++) {
            lb.options[i].text = arrTexts1[i];
            lb.options[i].value = arrTexts[i];
        }
    });

    //hide dropdown on load
    $('dropdown-hide').hide();

    // unhide dropdown upon change of another dropdown
    $('dropdown-hidechange').on('change', function () {

        var country = this.value.toLowerCase();

        $('dropdown-hide').hide()
            .show();
    });

    contactAttributes();

    $('.attr-select').change(function () {
        contactAttributes();
    });

    // clear table search / filter
    $(".clear-search").click(function () {
        var url = window.location.href;
        var splitUrl = url.substring(0, url.indexOf("?"));
        window.location.replace(splitUrl);
    });
    //add validation to website dropdowns
    $('.website-select').each(function () {
        $(this).attr('required', '');
        $(this).on({
            invalid: function (e) {
                e.target.setCustomValidity("");
                if (!e.target.validity.valid) {
                    e.target.setCustomValidity("Please select a website.");
                }
            },
            input: function (e) {
                e.target.setCustomValidity("");
            }
        });
    });

    $('input[type=search]').css('color', 'black');
    $('select[name=page-perms-table_length]').css('color', 'black');
    $('#page-perms-table_info').css('color', 'white');
    //var nodes1 = document.getElementsByClassName('paginate_button');
    //for (x = 0; x < nodes1.length; x++) {
    jQuery('.paginate_button').addClass('pagination-btn');

    $('#page-perms-table_paginate').addClass('table-pagination');
    $('#page-perms-table_paginate').attr('text-align', 'left !important');


    //   add pageItem to pageList if page is selected or remove if unselected
    var bns = $('input[name=pageItem]');
    bns.change(function (event) {
        var pageList = document.getElementById('pageList').value;
        if (event.target.checked) {
            document.getElementById('pageList').value = pageList + event.target.value + ';';
        } else {
            document.getElementById('pageList').value = pageList.replace(event.target.value + ';', '');
        }
    });
    //add pageItem to pageList if page is selected or remove if unselected on toggle of check all
    $('input[name=pageCheckAll]').change(function (event) {
        var nodes = document.getElementsByName("pageItem");
        for (x = 0; x < nodes.length; x++) {
            if (nodes[x].checked) {
                var pageList = document.getElementById('pageList').value;
                document.getElementById('pageList').value = pageList + nodes[x].value + ';';
            }
            else {
                pageList = document.getElementById('pageList').value;
                document.getElementById('pageList').value = pageList.replace(nodes[x].value + ';', '');
            }
        }
    });

    $('.copyButton').click(function (e) {
        var link = "";
        try {
            link = $(e.target.closest('td')).find("input:first").val().trim();
            copyToClipboard(link);
        }
        catch (err) {
            try {
                link = $(e.target.closest('td')).find("textarea:first").val().trim();
                copyToClipboard(link);
            }
            catch (err) {
                //do nothing
            }
        }
    });

    function contactAttributes() {
        var elements = [];
        $('.attr-select .open :selected').each(function() {
            elements.push($(this).text().trim());
        });
    }

    function copyToClipboard(elem) {
        var copyText = $("#clipboard").find("input");
        copyText.attr("val", elem).val(elem);
        copyText.select();
        document.execCommand("copy");
        alert("'" + copyText.val() + "' Copied to your clipboard!");
    }

    //close button
    $('.closeBtn').click(function() {
        $('.body-underlay').fadeOut();
        $('.search-sidebar').removeClass('open');
        $('.sidebar-tab-button').find('span').text("Open");
        $('.sidebar-tab-button').parent().removeClass('open');
    });

    // adds interatction to table toggle buttons
    $('.table-tab-group').find('.tab').click(function () {
        $('.tab').each(function () {
            $(this).removeClass('active');
            $(this).find('input').removeAttr('checked').removeAttr('checked');
        });
        
        $(this).addClass('active');
        $(this).find('input').attr('checked', 'checked').prop('checked', 'checked');
    });


    // controls tab body content on mouse click
    $('nav.ribbon-menu').find('li').click(function () {
        $('nav.ribbon-menu').find('li').each(function () {
            $(this).removeClass('active');
            $(this).find('.ribbon-body-container').addClass('hidden');
        });
        $(this).addClass('active');
        var tabBody = $(this).parent().parent().parent().find('.tab-body');
        var currentTabName = $(this).attr('name');

        // shows and hides content area depending on tab name selected
        tabBody.each(function () {
            if ($(this).attr('name') === currentTabName) {
                $(this).addClass('active');
            } else {
                $(this).removeClass('active');
            }
        });
    });

    //resize();
    resizeForm();

    $(window).on('zoom onload resize', function () {
        resize();
        resizeForm();
        resizeDL();
    });

    function resize() {
        //if table exists
        var tableLength = $('table').length;
        var iframeLength = $('iframe').length;
        var tableMax = 0;        
        
        for (var i = 0; i < tableLength; i++) {
            tableMax = Math.max(tableMax, $('table')[i].clientWidth);
        }
        if (tableLength > 0) {
        $('.container').removeAttr('style');
        $('html').removeAttr('style');
        if (tableLength > 0 && iframeLength <= 1) {
            //- parseInt($('.body-content').css("marginRight").replace('px', '')) - Math.max(parseInt($('.body-content').css("marginRight").replace('px', '')), 0)
            //if (tableMax > parseInt(document.body.scrollWidth) - 100 - Math.max(parseInt($('.body-content').css("marginLeft").replace('px', '')), 0)) {                
            if (document.body.scrollWidth > document.body.clientWidth) {
                realign(tableMax);
            }
            else {
                $('.container').removeAttr('style');
                $('html').removeAttr('style');
            }
        }
        else {
            $('.container').removeAttr('style');
            $('html').removeAttr('style');
            }
        }
    }

    function realign(tableMax) {
        //resize menu container on zoom
        //window.outerWidth
      //  var newWidth = (window.outerWidth() / tableMax * document.documentElement.clientWidth).toString() + 'vw';
        $('.container').css('left', '10px');
        $('.container').css('marginLeft', '30px');
        $('.body-content').css('marginLeft', '30px');
        //$('.body-content').css('marginRight', '10px'); //+ parseInt(130) + Math.max(parseInt($('.body-content').css("marginRight").replace('px', '')),0)
        $('html').css('width', (parseInt(tableMax) + Math.max(parseInt($('.body-content')[0].offsetLeft), 0) + 100).toString() + 'px');       
        
        $('html').css('position', 'relative');        
 
    }

    function resizeForm() {
        //if table exists
        var tableLength = $('form').length;
        var iframeLength = $('iframe').length;
        var tableMax = 0;

        for (var i = 0; i < tableLength; i++) {
            tableMax = Math.max(tableMax, $('form')[i].clientWidth);
        }
        if (tableLength > 0) {
        $('.container').removeAttr('style');
        $('html').removeAttr('style');
        if (tableLength > 0 && iframeLength <= 1) {
            //- parseInt($('.body-content').css("marginRight").replace('px', '')) - Math.max(parseInt($('.body-content').css("marginRight").replace('px', '')), 0)
            //if (tableMax > parseInt(document.body.scrollWidth) - 100 - Math.max(parseInt($('.body-content').css("marginLeft").replace('px', '')), 0)) {                
            if (document.body.scrollWidth > document.body.clientWidth) {
                realignForm(tableMax);
            }
            else {
                $('.container').removeAttr('style');
                $('html').removeAttr('style');
            }
        }
        else {
            $('.container').removeAttr('style');
            $('html').removeAttr('style');
            }
        }
    }

    function realignForm(tableMax) {
        //resize menu container on zoom
        //window.outerWidth
        //  var newWidth = (window.outerWidth() / tableMax * document.documentElement.clientWidth).toString() + 'vw';
        $('.container').css('left', '10px');
        $('.container').css('marginLeft', '30px');
        $('.body-content').css('marginLeft', '30px');
        //$('.body-content').css('marginRight', '10px'); //+ parseInt(130) + Math.max(parseInt($('.body-content').css("marginRight").replace('px', '')),0)    
        //$('html').css('width', (parseInt(tableMax) + Math.max(parseInt($('.body-content')[0].offsetLeft), 0) + 100).toString() + 'px');
        $('html').css('position', 'relative');

    }
    function resizeDL() {
        //if table exists
        var tableLength = $('dl').length;
        var iframeLength = $('iframe').length;
        var tableMax = 0;

        for (var i = 0; i < tableLength; i++) {
            tableMax = Math.max(tableMax, $('dl')[i].clientWidth);
        }
        if (tableLength > 0) {
            $('.container').removeAttr('style');
            $('html').removeAttr('style');
            if (tableLength > 0 && iframeLength <= 1) {
                //- parseInt($('.body-content').css("marginRight").replace('px', '')) - Math.max(parseInt($('.body-content').css("marginRight").replace('px', '')), 0)
                //if (tableMax > parseInt(document.body.scrollWidth) - 100 - Math.max(parseInt($('.body-content').css("marginLeft").replace('px', '')), 0)) {                
                if (document.body.scrollWidth > document.body.clientWidth) {
                    realignDL(tableMax);
                }
                else {
                    $('.container').removeAttr('style');
                    $('html').removeAttr('style');
                }
            }
            else {
                $('.container').removeAttr('style');
                $('html').removeAttr('style');
            }
        }
    }
    function realignDL(tableMax) {
        //resize menu container on zoom
        //window.outerWidth
        //  var newWidth = (window.outerWidth() / tableMax * document.documentElement.clientWidth).toString() + 'vw';
        $('.container').css('left', '10px');
        $('.container').css('marginLeft', '30px');
        $('.body-content').css('marginLeft', '30px');
        //$('.body-content').css('marginRight', '10px'); //+ parseInt(130) + Math.max(parseInt($('.body-content').css("marginRight").replace('px', '')),0)    
        $('html').css('width', (parseInt(tableMax) + Math.max(parseInt($('.body-content')[0].offsetLeft), 0) + 100).toString() + 'px');
        $('html').css('position', 'relative');

    }

    function _mapUrlParams(queryString) {
        return queryString
            .split('&')
            .map(function (keyValueString) { return keyValueString.split('=') })
            .reduce(function (urlParams, [key, value]) {
                if (Number.isInteger(parseInt(value)) && parseInt(value) == value) {
                    urlParams[key] = parseInt(value);
                } else {
                    urlParams[key] = decodeURI(value);
                }
                return urlParams;
            }, {});
    }
    function getUrlParams(urlOrQueryString) {
        if ((i = urlOrQueryString.indexOf('?')) >= 0) {
            const queryString = urlOrQueryString.substring(i + 1);
            if (queryString) {
                return _mapUrlParams(queryString);
            }
        }

        return {};
    }
});

//end of ready


// Capitalize words in string
function capitalize(s) {
    return s.toLowerCase().replace(/\b./g, function (a) { return a.toUpperCase(); });
}

//   add pageItem to pageList if page is selected or remove if unselected
var bns2 = $('input[name=pageItem]');
bns2.change(function (event) {
    var pageList = document.getElementById('pageList').value;
    if (event.target.checked) {
        document.getElementById('pageList').value = pageList + event.target.value + ';';
    } else {
        document.getElementById('pageList').value = pageList.replace(event.target.value + ';', '');
    }
});

//add pageItem to pageList if page is selected or remove if unselected on toggle of check all
$('input[name=pageCheckAll]').change(function (event) {
    var nodes = document.getElementsByName("pageItem");
    for (x = 0; x < nodes.length; x++) {
        if (nodes[x].checked) {
            var pageList = document.getElementById('pageList').value;
            document.getElementById('pageList').value = pageList + nodes[x].value + ';';
        }
        else {
            pageList = document.getElementById('pageList').value;
            document.getElementById('pageList').value = pageList.replace(nodes[x].value + ';', '');
        }
    }
});

// IE detection
function detectIE() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
        // Edge (IE 12+) => return version number
        //return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
        return false;
    }
    // other browser
    return false;
}

// finds number of contact attribute rows
function numberOfAttributeRows() {
    var contactAttrs = 0;
    $('.attr-select').each(function () {
        contactAttrs++;
    });
    return contactAttrs;
}

function countDuplicates(array) {
    array_elements = array.sort();
    array_elements.sort();
    var current = null;
    var cnt = 0;
    for (var i = 0; i < array_elements.length; i++) {
        if (array_elements[i] !== current) {
            if (cnt > 1) {
                return true;
            }
            current = array_elements[i];
            cnt = 1;
        } else {
            cnt++;
        }
    }
    if (cnt > 1) {
        return true;
    } else {
        return false;
    }
}
